import styled from 'styled-components';

export const StyledTransportListItem = styled.div`
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  cursor: pointer;
  gap: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;

export const TransportIconWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TransportDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 4px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;
